const systemRoles = {
  admin: "ef4baa00-8bef-48d6-b7da-ed2a2be3d347",
  organizationAdmin: "5f933db3-f3bc-4664-8020-e91834214beb",
  support: "45ae2096-c18c-4159-a98e-0cc95ed262c8",
  unprivileged: "1b6c8adb-bbbc-4dce-8cad-e4e7a715b5c6",
};

export { systemRoles };
